import { getAccreditationFiles } from '../../util/api';
import { storableError } from '../../util/errors';
import { createImageVariantConfig } from '../../util/sdkLoader';

// ================ Action types ================ //

export const SET_INITIAL_STATE = 'app/AccreditationPage/SET_INITIAL_STATE';

export const GET_FILES_REQUEST = 'app/AccreditationPage/GET_FILES_REQUEST';
export const GET_FILES_SUCCESS = 'app/AccreditationPage/GET_FILES_SUCCESS';
export const GET_FILES_ERROR = 'app/AccreditationPage/GET_FILES_ERROR';

// ================ Reducer ================ //

const initialState = {
  userListings: [],
  getFilesError: null,
  getFilesInProgress: false,
};

export default function accreditationPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case SET_INITIAL_STATE:
      return { ...initialState };

    case GET_FILES_REQUEST:
      return {
        ...state,
        getFilesInProgress: true,
        getFilesError: null,
      };
    case GET_FILES_SUCCESS:
      return { ...state, getFilesInProgress: false, files: payload.files };
    case GET_FILES_ERROR:
      return { ...state, getFilesInProgress: false, getFilesError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const setInitialState = () => ({
  type: SET_INITIAL_STATE,
});

export const getFilesRequest = () => ({
  type: GET_FILES_REQUEST,
});

export const getFilesSuccess = files => ({
  type: GET_FILES_SUCCESS,
  payload: { files },
});

export const getFilesError = e => ({
  type: GET_FILES_ERROR,
  error: true,
  payload: e,
});


// ================ Thunks ================ //


export const loadTransactionFiles = () => (dispatch, getState, sdk) => {
  dispatch(getFilesRequest());
  const state = getState().user;
  const currentUser = state.currentUser;

  return getAccreditationFiles({ userId: currentUser?.id?.uuid })
    .then(res => {
      dispatch(getFilesSuccess(res?.batches));
      return res?.batches;
    })
    .catch(() => {
      dispatch(getFilesError("Query files failed."));
    });
};


export const loadData = (params, search, config) => (dispatch, getState, sdk) => {
  dispatch(setInitialState());

  return Promise.all([dispatch(loadTransactionFiles(config))]);
};
